import { PaidStatus, Project } from 'store/api/apiTypes';

export const isProjectPaid = (p: Project) => p.paid === PaidStatus.PAID;
export const isProjectTrial = (p: Project) => p.paid === PaidStatus.TRIAL;
export const isProjectExpired = (p: Project) => p.paid === PaidStatus.EXPIRED;
export const isProjectReportReady = (p: Project) =>
  p.reports?.[0]?.status === 'READY';
export const isProjectReportGenerating = (p: Project) =>
  p.reports?.[0]?.status === 'BUSY' || !p.reports || p.reports.length === 0;
